var compactable = require('./compactable');

function restoreWithComponents(property) {
  var descriptor = compactable[property.name];

  if (descriptor && descriptor.shorthand) {
    return descriptor.restore(property, compactable);
  } else {
    return property.value;
  }
}

module.exports = restoreWithComponents;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/optimizer/level-2/restore-with-components.js
// module id = 677
// module chunks = 0